import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../../contexts/auth';
import NotificatioList from '../Notification/NotificatioList';
import useScreenSize from '../../hooks/useScreenSize';

export default function Header() {
  const {
    user,
    user: { organization },
    logout,
    isAdmin,
  } = useAuth();
  const { pathname } = useLocation();
  const [menuActivated, setMenuActivated] = useState('');
  const [screenWidth, screenHeight] = useScreenSize();

  useEffect(() => {
    setMenuActivated(pathname);
  }, [pathname]);

  return (
    <nav className='navbar navbar-expand-lg navbar-dark bg-dark'>
      <div className='container'>
        <button
          className='navbar-toggler'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#navbarHeader'
          aria-controls='navbarHeader'
          aria-expanded='false'
          aria-label='Exibir/ocultar menu'
        >
          <span className='navbar-toggler-icon' />
        </button>
        <div className='d-flex align-items-center gap-2'>
          <div>
            <Link className='navbar-brand m-0' to='/'>
              Project OS
            </Link>
          </div>
          {isAdmin && (screenWidth < 576 || screenHeight < 576) && (
            <NotificatioList />
          )}
        </div>
        <div className='collapse navbar-collapse' id='navbarHeader'>
          <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
            {isAdmin && organization.id !== 102 && (
              <li className='nav-item'>
                <Link
                  className={`nav-link ${
                    menuActivated.includes('estimates') ? 'active' : ''
                  }`}
                  aria-current='page'
                  to='/estimates'
                >
                  Orçamentos
                </Link>
              </li>
            )}
            <li className='nav-item'>
              <Link
                className={`nav-link ${
                  menuActivated.includes('invoices') ? 'active' : ''
                }`}
                aria-current='page'
                to='/invoices'
              >
                Ordens de Serviço
              </Link>
            </li>
            {isAdmin && (
              <li className='nav-item'>
                <Link
                  className={`nav-link ${
                    menuActivated.includes('customers') ? 'active' : ''
                  }`}
                  to='/customers'
                >
                  Clientes
                </Link>
              </li>
            )}

            {isAdmin && (
              <li className='nav-item dropdown'>
                <Link
                  className='nav-link dropdown-toggle'
                  to='/'
                  id='navbarScrollingDropdown'
                  role='button'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                >
                  Cadastros
                </Link>
                <ul
                  className='dropdown-menu dropdown-menu-dark'
                  aria-labelledby='navbarScrollingDropdown'
                >
                  <li>
                    <Link
                      className={`dropdown-item ${
                        menuActivated.includes('products') ? 'bg-secondary' : ''
                      }`}
                      to='/products'
                    >
                      Produtos
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`dropdown-item ${
                        menuActivated.includes('services') ? 'bg-secondary' : ''
                      }`}
                      to='/services'
                    >
                      Serviços
                    </Link>
                  </li>
                  <li>
                    <hr className='dropdown-divider' />
                  </li>
                  <li>
                    <Link
                      className={`dropdown-item ${
                        menuActivated.includes('companies')
                          ? 'bg-secondary'
                          : ''
                      }`}
                      to='/companies'
                    >
                      Minhas Empresas
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`dropdown-item ${
                        menuActivated.includes('admin/users')
                          ? 'bg-secondary'
                          : ''
                      }`}
                      to='/admin/users'
                    >
                      Colaboradores
                    </Link>
                  </li>
                  <li>
                    <hr className='dropdown-divider' />
                  </li>
                  <li>
                    <Link
                      className={`dropdown-item ${
                        menuActivated.includes('invoice-statuses')
                          ? 'bg-secondary'
                          : ''
                      }`}
                      to='/invoice-statuses'
                    >
                      Situações de OS
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`dropdown-item ${
                        menuActivated.includes('transaction-natures')
                          ? 'bg-secondary'
                          : ''
                      }`}
                      to='/transaction-natures'
                    >
                      Naturezas da Transação
                    </Link>
                  </li>
                  {organization.id !== 102 && (
                    <li>
                      <Link
                        className={`dropdown-item ${
                          menuActivated.includes('reminders')
                            ? 'bg-secondary'
                            : ''
                        }`}
                        to='/reminders'
                      >
                        Lembretes
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link
                      className={`dropdown-item ${
                        menuActivated.includes('tags') ? 'bg-secondary' : ''
                      }`}
                      to='/tags'
                    >
                      Etiquetas
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {isAdmin && organization.id !== 102 && (
              <>
                <li className='nav-item'>
                  <Link
                    className={`nav-link ${
                      menuActivated.includes('customers') ? 'active' : ''
                    }`}
                    to='/reports'
                  >
                    Relatórios
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link
                    className={`nav-link ${
                      menuActivated.includes('payrolls') ? 'active' : ''
                    }`}
                    aria-current='page'
                    to='/payrolls'
                  >
                    Folha
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link
                    className={`nav-link ${
                      menuActivated.includes('audit-logs') ? 'active' : ''
                    }`}
                    aria-current='page'
                    to='/audit-logs'
                  >
                    Logs
                  </Link>
                </li>
              </>
            )}
          </ul>
          <ul className='navbar-nav'>
            <li className='nav-item dropdown'>
              <Link
                className='nav-link active dropdown-toggle'
                to='/'
                id='navbarScrollingDropdown'
                role='button'
                data-bs-toggle='dropdown'
                aria-expanded='false'
              >
                {user?.name}
              </Link>
              <ul
                className='dropdown-menu dropdown-menu-lg-end dropdown-menu-dark'
                aria-labelledby='navbarScrollingDropdown'
              >
                <li>
                  <Link className='dropdown-item' to='/profile'>
                    Perfil
                  </Link>
                </li>
                <li>
                  <a
                    href='/'
                    className='dropdown-item d-flex align-items-center gap-2'
                    onClick={logout}
                  >
                    <FaSignOutAlt />
                    <span>Sair</span>
                  </a>
                </li>
              </ul>
            </li>
            <li className='d-flex align-items-center nav-item'>
              {isAdmin &&
                organization.id !== 102 &&
                screenWidth > 576 &&
                screenHeight > 576 && <NotificatioList />}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
